var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.19526 13.1377C4.93491 12.8774 4.93491 12.4553 5.19526 12.1949L9.39052 7.99967L5.19526 3.80441C4.93491 3.54406 4.93491 3.12195 5.19526 2.8616C5.45561 2.60125 5.87772 2.60125 6.13807 2.8616L10.8047 7.52827C11.0651 7.78862 11.0651 8.21073 10.8047 8.47108L6.13807 13.1377C5.87772 13.3981 5.45561 13.3981 5.19526 13.1377Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRight);
export default __webpack_public_path__ + "static/media/ic-right.7aad1c814f7fa1ffda830dbe6d54612a.svg";
export { ForwardRef as ReactComponent };